import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import WarningIcon  from 'shared/assets/icons/warningicon.svg';

export interface ConfirmDobUpdateModalProps {
    isDobModalOpen: boolean;
    handleDobUpdateAgree: () => void;
    handleDobUpdateDisagree: () => void;
}

const styles = {
    paragraph : {
        fontFamily: 'InterRegular',
        color: '#615F6B',
        fontSize: { xs: 12, md: 15, lg: 16 },
        lineHeight: { xs: 1.2, md: 1.2, lg: 1.5 },
    },
    button: {
        width: { xs: '40%', md: '30%' },
        borderRadius: '10px',
        fontSize: { xs: 12, md: 14 },
        boxShadow: 'unset',
        border: '1px solid #9135E0',
    }
}
const ConfirmBoBUpdateModal = ({
    isDobModalOpen,
    handleDobUpdateAgree,
    handleDobUpdateDisagree
}: ConfirmDobUpdateModalProps) => {
    return (
    <Dialog
        open={isDobModalOpen}
        onClose={handleDobUpdateDisagree}
        disableEscapeKeyDown={false}
        PaperProps={{
            sx: {
            borderRadius: '10px',
            padding: { xs: 5, sm: 6, md: 8 },
            width: {xs: '80%', sm: '50%', lg: '40%'},
            maxWidth: '600px',
            background: '#fff',
            outline: 'none',
            },
        }}
        slotProps={{
            backdrop: {
            sx: {
                backdropFilter: 'blur(5px)',
                background: 'rgba(0, 0, 0, 0.01)',
            },
          }
        }}
        >
        <DialogTitle sx={{ padding:0, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <img src={WarningIcon} style={{  width: '8vw', maxWidth: '100px', minWidth: '60px', height: 'auto', }} />
            <Typography
            textAlign="center"
            sx={{
                fontSize: { xs: 18, md: 22, lg: 24},
                fontWeight: 600,
                lineHeight: { xs: 1, md: 1.2, lg: 1.5 },
            }}
            >
            Last Chance to Update
            </Typography>
        </DialogTitle>

        <DialogContent 
            sx={{ textAlign: 'left', 
                pl: {xs:2, md: 8, lg: 10}, 
                pr: 4, 
                py: 0,
                mt: {xs: 2, lg: 0},
            }}
        >
            <Typography
            color="#615F6B"
            sx={styles.paragraph}
            >
            This is your last chance to update your date of birth. 
            </Typography>
             <Typography
                color="#615F6B"
                sx={{
                ...styles.paragraph,
                }}
            >
                Please note:
            </Typography>

            <Box
                component="ul"
                sx={{
                ...styles.paragraph,
                pl: {xs: 6, md: 8, lg: 10}, 
                m: 0,
                }}
            >
                <li>Your previous scan records will be permanently deleted.</li>
                <li>New scan records will be generated after the update.</li>
            </Box>

            <Typography
                sx={styles.paragraph}
            >
                Do you want to continue?
            </Typography>
        </DialogContent>

        <DialogActions 
            sx={{ 
                justifyContent: 'center', 
                gap: {xs: 1, md: 4, lg: 6}, 
                mt: 4, 
                p: 0
            }}
            >
            <Button
            onClick={handleDobUpdateDisagree}
            sx={{
                ...styles.button,
                background: 'transparent',
                color: '#9135E0',
                ':hover': { background: 'transparent' },
            }}
            >
            No
            </Button>

            <Button
            onClick={handleDobUpdateAgree}
            sx={{
                ...styles.button,
                background: '#9135E0',
                color: '#fff',
                ':hover': { background: '#9135E0' },
            }}
            autoFocus
            >
            Yes
            </Button>
        </DialogActions>
    </Dialog>
    )
}
export default ConfirmBoBUpdateModal;